import { getDeviceType } from "../../../../../themes/custom/ev_theme/frontend/js/common/constants/variables/globalVariables";
import { checkTopComponent } from "../../../../../themes/custom/ev_theme/frontend/js/components/ads";
import { loadAnalyticsEvent } from "../../../../../themes/custom/ev_theme/frontend/js/components/gtag";
import { createDynamicSlider, createStaticSlider } from "../../../../../themes/custom/ev_theme/frontend/js/components/sliders";
import { dataCalculator } from "../../../../../themes/custom/ev_theme/frontend/js/modules/form/setValueForm";
import { fillBuilderHtml } from "../builder-filter";
import { filterIndex, filterNid, filterString } from "./results-load/results-query";
window.showSimulationData = showSimulationData;
/**
 * Load results if there are no results based on the department.
 * This function handles tab navigation if no results are found.
 *
 * @param {number} number_total - Total number of results
 */
export async function loadWithoutResults(number_total) {
    var _a, _b, _c, _d;
    if (number_total === 0) {
        const departmentElement = document.getElementById('id-department');
        let idDepartment = (_b = (_a = departmentElement === null || departmentElement === void 0 ? void 0 : departmentElement.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
        let data = document.getElementById('app') ? JSON.parse(document.getElementById('app').dataset.projects || '') : {};
        if (data.cities && !departmentElement) {
            const res = await fetch(`/api/ev-results-search?cities=${data.cities}`);
            const finalRes = await res.json();
            idDepartment = finalRes.facetas.field_location_department.length > 0 ? finalRes.facetas.field_location_department[0].tid : '0';
        }
        const departmentToTabMap = {
            "20620": ".tab-project-19993",
            "20605": ".tab-project-19994",
            "20606": ".tab-project-30991",
            "20607": ".tab-project-30993",
            "20614": ".tab-project-30995",
            "20618": ".tab-project-19995",
            "20609": ".tab-project-19996",
            "20616": ".tab-project-19996",
            "20617": ".tab-project-19996"
        };
        if (idDepartment != '0') {
            const tab = departmentToTabMap[idDepartment];
            if (tab) {
                const tabElement = document.querySelector(tab);
                tabElement === null || tabElement === void 0 ? void 0 : tabElement.click();
            }
            if (document.getElementById('featured-zones') && document.getElementById('featured-project')) {
                (_c = document.getElementById('featured-zones')) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
                document.getElementById('featured-project').style.display = 'block';
            }
        }
        else {
            (_d = document.getElementById('featured-zones')) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
            document.getElementById('featured-project').style.display = 'block';
        }
    }
}
/**
 * Toggles the visibility of the mobile filter order.
 * Updates the icon depending on the visibility state of the filter.
 */
export function toggleFilterOrder() {
    const filterOrderMobile = document.querySelector('.filters-order-mobile');
    const resultsOrderMobile = document.querySelector('.js-results-order .js-results-content-filters');
    if (filterOrderMobile && resultsOrderMobile) {
        const isVisible = filterOrderMobile.classList.contains('d-block');
        filterOrderMobile.classList.toggle('d-block', !isVisible);
        filterOrderMobile.classList.toggle('hidden-filter', isVisible);
        resultsOrderMobile.classList.toggle('d-block', !isVisible);
    }
}
/**
 * Closes the mobile filter if the user clicks outside of the filter menu.
 *
 * @param {MouseEvent} e - The click event
 */
export function closeFilterOrderMobile(e) {
    const itemsFilter = document.querySelector('.js-results-order .js-results-content-filters');
    const filterOrderMobile = document.querySelector('.filters-order-mobile');
    if (itemsFilter && filterOrderMobile && !itemsFilter.contains(e.target) && !filterOrderMobile.contains(e.target)) {
        filterOrderMobile.classList.remove('d-block');
        itemsFilter.classList.remove('d-block');
    }
}
/**
 * Loads more results dynamically based on the current filter and range.
 * Handles both builder and non-builder types, adjusting the UI accordingly.
 *
 * @param {boolean} isBuilder - Indicates if the request is for a builder or not
 * @param {boolean} isFirst - indicates if the function is called on first load
 */
export async function loadMoreResults(isBuilder, isFirst) {
    var _a, _b, _c, _d;
    const loadingElementId = isBuilder ? 'loading-results-builder' : 'loading-results';
    const moreResultsId = isBuilder ? 'more-results-builder' : 'more-results';
    const endResultsId = isBuilder ? 'end-results-builder' : 'end-results';
    (_a = document.getElementById(loadingElementId)) === null || _a === void 0 ? void 0 : _a.classList.add('d-flex');
    let filter = filterString();
    let rangeValue = isBuilder ? window.rangeValueBuilder : window.rangeValue;
    if (!isFirst) {
        rangeValue += 9;
        isBuilder ? window.rangeValueBuilder += 9 : window.rangeValue += 9;
    }
    if (!filter) {
        filter = `?range=${rangeValue}`;
    }
    else {
        filter += `&range=${rangeValue}`;
    }
    filter = filterNid(filter);
    filter = filterIndex(filter);
    const res = await fetch(`/results-api${filter}&start=1&url=${window.location.pathname}${isBuilder ? '&result-type=1' : ''}`);
    const finalRes = await res.json();
    if (isBuilder) {
        fillBuilderHtml(finalRes.Items);
    }
    else {
        document.getElementById('first-results-section').innerHTML = '';
        const featuredProjectsResults = document.getElementById('featuredProjectsResults');
        if (featuredProjectsResults)
            featuredProjectsResults.innerHTML = '';
        window.app.datos1 = finalRes.Items;
        window.app.featuredProjects = finalRes.outputFeatured;
    }
    document.getElementById('number-total').innerHTML = finalRes.NumItems;
    if (finalRes.NumItems >= 12 && rangeValue > finalRes.NumItems) {
        (_b = document.getElementById(endResultsId)) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    }
    if (finalRes.NumItems < 12 || rangeValue > finalRes.NumItems) {
        (_c = document.getElementById(moreResultsId)) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
    }
    if (!isBuilder) {
        setTimeout(() => {
            window.app.datos1.forEach((element) => {
                if (element.field_images.length > 1) {
                    const cardElement = document.getElementById('splide' + element.field_node_id);
                    createStaticSlider(cardElement, {
                        perPage: 1,
                        classes: { arrow: 'splide__arrow splide__arrow--blue' },
                    }, { lazy: true });
                }
                if (element.field_sustainable_logo !== '' && window.location.href.split('/')[3] === 'construcciones-sostenibles') {
                    document.querySelectorAll('#sustainableBrand').forEach(brand => brand.classList.remove('d-none'));
                }
                const downPaymentPercentage = 30;
                const yearsTerm = 20;
                element.field_montly_quote = dataCalculator.calculateQuote(element.field_typology_price, element.field_tipo_de_vivienda, downPaymentPercentage, yearsTerm);
            });
        }, 200);
        setTimeout(() => {
            loadSliderHiglighted('featuredProjectsVue');
        }, 300);
        loadAds();
    }
    (_d = document.getElementById(loadingElementId)) === null || _d === void 0 ? void 0 : _d.classList.remove('d-flex');
    closeAllSimulationData();
}
/**
 * Loads slider highlighted results.
 */
export function loadSliderHiglighted(id) {
    const el = document.getElementById(id);
    if (!el)
        return;
    requestAnimationFrame(() => {
        const slides = el.querySelectorAll('.splide__slide');
        const featuredCards = el.querySelectorAll('.card-project--accentuate');
        const splideArrows = featuredCards.length < 4 ? false : true;
        if (slides.length > 0) {
            createDynamicSlider(el, {
                type: 'slide',
                perPage: 3,
                rewind: true,
                arrows: splideArrows,
                pagination: true,
                breakpoints: {
                    768: {
                        perPage: 1,
                    },
                },
            });
        }
    });
}
// Determine if the device is mobile or desktop
const valueDevice = getDeviceType();
const cantidadBanners = valueDevice === 'mobile' ? [78, 36, 75] : [255, 19, 223, 225];
/**
 * Function to load advertisements dynamically based on device type and page content.
 */
export function loadAds() {
    document.querySelectorAll(".content-card-banner").forEach(e => e.remove());
    setTimeout(() => {
        if (!document.getElementById('js-unpublished-project')) {
            document.querySelectorAll('.js-card-project:not(.card-project--accentuate)').forEach((element, index) => {
                element.classList.toggle("js-card-ads-banner", (index + 1) % 6 === 0);
            });
        }
        const contentAds = document.querySelectorAll(".js-card-ads-banner");
        const valueFunctionForm = "banner-ads";
        contentAds.forEach((card, index) => {
            if (index <= cantidadBanners.length) {
                const valueContent = `zone-${cantidadBanners[index]}`;
                const divAds = createAdElement(valueContent, valueFunctionForm);
                // Make an AJAX request to fetch the ad content
                fetchAdContent(cantidadBanners[index], divAds, card);
            }
        });
        window.onload = checkTopComponent;
        checkTopComponent();
        loadAnalyticsEvent();
    }, 10);
}
/**
 * Creates an ad element with required attributes and classes.
 *
 * @param {string} valueContent - The content identifier for the ad
 * @param {string} valueFunctionForm - The function form identifier
 * @returns {HTMLDivElement} The created ad div element
 */
function createAdElement(valueContent, valueFunctionForm) {
    const divAds = document.createElement("div");
    divAds.setAttribute('valueFunctionForm', valueFunctionForm);
    divAds.setAttribute('valueContent', valueContent);
    divAds.setAttribute('id', valueContent);
    divAds.classList.add('content-card-banner', 'open-btn', 'form-ads-result');
    return divAds;
}
/**
 * Fetches the ad content from the server and inserts it into the provided div.
 *
 * @param {number} zoneId - The zone ID for the ad
 * @param {HTMLDivElement} divAds - The div element to insert the ad content into
 * @param {Element} card - The content card element where the ad will be placed
 */
function fetchAdContent(zoneId, divAds, card) {
    var _a;
    const adUrl = `https://ads.estrenarvivienda.com/www/delivery/ajs.php?zoneid=${zoneId}&cb=${Math.floor(Math.random() * 99999999999)}&charset=UTF-8&loc=${escape(window.location.href)}`;
    fetch(adUrl)
        .then(response => response.text())
        .then(data => {
        const bannerContent = extractBannerContent(data);
        if (bannerContent) {
            divAds.innerHTML = bannerContent;
            adjustPageLayout(bannerContent, divAds);
        }
    });
    (_a = card.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(divAds, card.nextSibling);
}
/**
 * Extracts the banner content from the fetched data.
 *
 * @param {string} data - The raw response data from the ad server
 * @returns {string} The extracted banner content
 */
function extractBannerContent(data) {
    var _a;
    const valueData = data.split('document')[0];
    const valueVar = (_a = valueData.split('+= "')[1]) === null || _a === void 0 ? void 0 : _a.split('n";').join('').split('"+"').join('');
    return valueVar ? valueVar.replace(/\\/g, '') : '';
}
function setScrollAds() {
    const header = document.getElementById('header');
    const page = document.getElementById('page');
    header === null || header === void 0 ? void 0 : header.classList.add('header-banner');
    page === null || page === void 0 ? void 0 : page.classList.add('page-banner');
    window.addEventListener('scroll', function () {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (scrollPosition > 70) {
            header === null || header === void 0 ? void 0 : header.classList.remove('header-banner');
            page === null || page === void 0 ? void 0 : page.classList.remove('page-banner');
        }
        else {
            header === null || header === void 0 ? void 0 : header.classList.add('header-banner');
            page === null || page === void 0 ? void 0 : page.classList.add('page-banner');
        }
    });
}
/**
 * Adjusts the page layout based on the banner content.
 *
 * @param {string} bannerContent - The content of the banner
 * @param {HTMLDivElement} divAds - The ad div element
 */
function adjustPageLayout(bannerContent, divAds) {
    var _a;
    if (bannerContent.includes("width='400'")) {
        const valueContent = divAds.getAttribute('valueContent');
        if (valueContent === 'zone-78' || valueContent === 'zone-257') {
            (_a = document.querySelector('.projects__header')) === null || _a === void 0 ? void 0 : _a.setAttribute('style', 'margin-top: 50px');
            setScrollAds();
            const contentContador = document.getElementById('content-fair-contador');
            contentContador === null || contentContador === void 0 ? void 0 : contentContador.classList.add('contador-banner');
        }
    }
}
/**
 * Toggles the view between 'proyectos' (projects) and other sections.
 * - Shows or hides the builder and result sections based on the selected view.
 * - Moves necessary DOM elements (filter, map, etc.) to appropriate containers.
 *
 * @param value - The view mode. Accepts 'proyectos' to display projects or 'other' for other views.
 */
export function openBuilderProjects(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    // Safely get elements from the DOM
    const containerBuilder = document.getElementById('projects-builder');
    const containerBuilderResults = document.getElementById('projects-by-builder');
    const filter = document.getElementById('results-header');
    const filterMobile = document.getElementById('filters__mobile');
    const filterMobileBuilder = document.getElementById('filters__mobile-builder');
    const containerFilterMobile = document.getElementById('content-projects');
    const containerHeader = document.getElementById('content-header');
    const containerMapBuilder = document.getElementById('content-map-section-builder');
    const containerMap = document.getElementById('container-map');
    const map = document.getElementById('content-map');
    if (value === 'proyectos') {
        (_a = document.querySelector('.js-typologies-option')) === null || _a === void 0 ? void 0 : _a.classList.remove('active');
        (_b = document.querySelector('.js-projects-option')) === null || _b === void 0 ? void 0 : _b.classList.add('active');
        (_c = document.querySelector('.js-typologies-option-mobile')) === null || _c === void 0 ? void 0 : _c.classList.remove('active');
        (_d = document.querySelector('.js-projects-option-mobile')) === null || _d === void 0 ? void 0 : _d.classList.add('active');
        containerBuilder === null || containerBuilder === void 0 ? void 0 : containerBuilder.classList.remove('d-none');
        filterMobile === null || filterMobile === void 0 ? void 0 : filterMobile.classList.add('d-none');
        filterMobileBuilder === null || filterMobileBuilder === void 0 ? void 0 : filterMobileBuilder.classList.remove('d-none');
        (_e = document.querySelector('.js-results-cards')) === null || _e === void 0 ? void 0 : _e.classList.add('d-none');
        containerBuilderResults === null || containerBuilderResults === void 0 ? void 0 : containerBuilderResults.insertBefore(filter, containerBuilderResults.firstChild);
        containerMapBuilder === null || containerMapBuilder === void 0 ? void 0 : containerMapBuilder.append(map);
    }
    else {
        (_f = document.querySelector('.js-projects-option')) === null || _f === void 0 ? void 0 : _f.classList.remove('active');
        (_g = document.querySelector('.js-typologies-option')) === null || _g === void 0 ? void 0 : _g.classList.add('active');
        (_h = document.querySelector('.js-projects-option-mobile')) === null || _h === void 0 ? void 0 : _h.classList.remove('active');
        (_j = document.querySelector('.js-typologies-option-mobile')) === null || _j === void 0 ? void 0 : _j.classList.add('active');
        containerBuilder.classList.add('d-none');
        filterMobile === null || filterMobile === void 0 ? void 0 : filterMobile.classList.remove('d-none');
        filterMobileBuilder === null || filterMobileBuilder === void 0 ? void 0 : filterMobileBuilder.classList.add('d-none');
        (_k = document.querySelector('.js-results-cards')) === null || _k === void 0 ? void 0 : _k.classList.remove('d-none');
        containerHeader.append(filter);
        containerFilterMobile.append(filterMobile);
        containerMap.append(map);
    }
}
/**
 * Loads the certificate (for sustainable brand visibility) based on the URL.
 *
 * @param {string[]} urlPerSection - The split URL segments
 */
export function loadCertificate(urlPerSection) {
    if (urlPerSection[3] === "construcciones-sostenibles") {
        document.querySelectorAll('#sustainableBrand').forEach(brand => {
            brand.classList.remove('d-none');
        });
    }
}
function currentCardsPerRow() {
    if (window.matchMedia('(min-width: 992px)').matches)
        return 3;
    if (window.matchMedia('(min-width: 768px)').matches)
        return 2;
    return 1;
}
function getCards(gridName) {
    const grid = document.getElementById(gridName);
    if (!grid)
        return [];
    return Array.from(grid.querySelectorAll('.js-card-project.result-card'));
}
function assignRows(gridName) {
    const cards = getCards(gridName);
    const cardsPerRow = currentCardsPerRow();
    cards.forEach((card, i) => {
        const row = Math.floor(i / cardsPerRow);
        card.setAttribute('data-row', String(row));
    });
}
function getRowCardsFrom(nodeId, gridName) {
    const originSummary = document.getElementById(`simulationDataSummary-${nodeId}`);
    const originCard = (originSummary === null || originSummary === void 0 ? void 0 : originSummary.closest('.js-card-project')) || null;
    if (!originCard)
        return [];
    const row = originCard.getAttribute('data-row');
    if (row == null)
        return [];
    const grid = document.getElementById(gridName);
    if (!grid)
        return [];
    return Array.from(grid.querySelectorAll(`.js-card-project[data-row="${row}"]`));
}
function toggleRow(open, nodeId, gridName) {
    assignRows(gridName);
    const rowCards = getRowCardsFrom(nodeId, gridName);
    rowCards.forEach(card => {
        const summary = card.querySelector('[id^="simulationDataSummary-"]');
        const content = card.querySelector('[id^="simulationDataContent-"]');
        if (!summary || !content)
            return;
        if (open) {
            summary.classList.add('d-none');
            content.classList.remove('d-none');
        }
        else {
            content.classList.add('d-none');
            summary.classList.remove('d-none');
        }
    });
}
export function showSimulationData(nodeId, show, event) {
    let gridName;
    if (nodeId === 'card') {
        const target = event === null || event === void 0 ? void 0 : event.target;
        nodeId = (target === null || target === void 0 ? void 0 : target.getAttribute('typology-id')) || '';
        gridName = 'datos1';
    }
    else {
        gridName = 'first-results-section';
    }
    if (nodeId)
        toggleRow(show, nodeId, gridName);
}
export function closeAllSimulationData() {
    document.querySelectorAll('[id^="simulationDataContent-"]').forEach(el => el.classList.add('d-none'));
    document.querySelectorAll('[id^="simulationDataSummary-"]').forEach(el => el.classList.remove('d-none'));
}
